import { createContext, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const CrumbCtx = createContext({ names: {}, set: () => {} });
export const SALES = ["New", "Contacted", "Quote sent", "Lost"];
export const WIDGETS = { messages: "Messages", brief: "Brief", timeline: "Timeline & calendar", payments: "Quotes & payments", notes: "Internal notes", revisions: "Revisions & post", upsell: "Upsell", tasks: "Tasks", crew: "Crew", post: "Post-production", files: "Files", quote: "Quote" };
const TOP = { leads: "Pipeline", projects: "Projects", quotes: "Quotes", invoices: "Invoices", reports: "Reporting", contacts: "Contacts", companies: "Companies", tasks: "Tasks", availability: "Availability", cms: "Website CMS", users: "Team", pricing: "Pricing & add-ons", promotions: "Promotions", post: "Post queue" };

export function useCrumb(id, name, stage) {
  const { set } = useContext(CrumbCtx);
  useEffect(() => { if (id && name) set(id, { name, stage }); }, [id, name, stage]); // eslint-disable-line react-hooks/exhaustive-deps
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const { names } = useContext(CrumbCtx);
  const segs = pathname.split("/").filter(Boolean);
  const c = [{ label: "Dashboard", to: "/admin" }];
  const [, s1, s2, s3] = segs;
  if (s1 === "projects" && s2) {
    const rec = names[s2];
    c.push(rec && SALES.includes(rec.stage) ? { label: "Pipeline", to: "/admin/leads" } : { label: "Projects", to: "/admin/projects" });
    c.push({ label: rec?.name || "Project", to: `/admin/projects/${s2}` });
    if (s3) c.push({ label: WIDGETS[s3] || s3 });
  } else if (s1) {
    c.push({ label: TOP[s1] || s1, to: `/admin/${s1}` });
    if (s2) c.push({ label: s2 === "new" ? "New quote" : names[s2]?.name || "Details" });
  }
  return (
    <nav className="flex items-center flex-wrap gap-1 text-sm mb-5" data-testid="breadcrumbs">
      {c.map((x, i) => <span key={i} className="inline-flex items-center gap-1">{i > 0 && <ChevronRight size={13} className="text-brand-purpleDeep/30" />}{i < c.length - 1 && x.to ? <Link to={x.to} className="text-brand-purple hover:underline" data-testid={`crumb-${i}`}>{x.label}</Link> : <span className="text-brand-purpleDeep/70 font-semibold truncate max-w-[260px]" data-testid={`crumb-${i}`}>{x.label}</span>}</span>)}
    </nav>
  );
}
